import { useQuery } from "@tanstack/react-query";
import { userSurveysApi } from "api/userSurveysApi";
import { QUERIES_KEYS } from "queries";

export const useUserSurveyById = (id: number | null) => {
  const { isLoading, data } = useQuery({
    queryKey: QUERIES_KEYS.USER_SURVEY_BY_ID(id!),
    queryFn: () => userSurveysApi.fetchById(id!),
    enabled: id !== null,
  });

  return { isLoading, survey: data?.data ?? null };
};
